module.exports = __webpack_public_path__ + "static/media/backgroud.d62cf324.png";